export function setUser (state, user) {
  state._user = user
}
